var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('i',{staticClass:"icon-set icon",domProps:{"innerHTML":_vm._s(_vm.iconContent)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }